// Pure core for Comfy review. Zero supabase imports — unit-tested in isolation.

/** A reviewer is a superadmin OR an MD (clinical role). Both fields ride in the
 *  signed session (authenticateStaff returns role + system_role) and on the
 *  client in useAppData().user. NPs / cosmetólogas / recepción are NOT reviewers
 *  in this rollout. */
export function isComfyReviewer(
  u?: { system_role?: string | null; role?: string | null } | null,
): boolean {
  if (!u) return false;
  return u.system_role === 'superadmin' || (u.role ?? '').trim().toUpperCase() === 'MD';
}

/** The user message that TRIGGERED the latest assistant answer — the LAST
 *  user-role message, not the first. The QA classifier + the stored review row
 *  must use this. The old `.find()` returned the FIRST user message, so in a
 *  multi-turn chat it graded/stored an old question against the newest answer
 *  (e.g. chat opened with "Sculptra", later asked "toxina botulínica" →
 *  answered Botox, but the review showed question="Sculptra"/answer=Botox) —
 *  manufacturing false "wrong treatment" failures and inflating the flag rate. */
export function triggeringUserMessage(
  messages: ReadonlyArray<{ role: string; content: string }>,
): string {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i].role === 'user') return messages[i].content ?? '';
  }
  return '';
}

export type ReviewAction = 'approve' | 'correct' | 'dismiss';

/** Reviewer action → the resolved status persisted on the review row. */
export const ACTION_STATUS: Record<ReviewAction, 'approved' | 'corrected' | 'dismissed'> = {
  approve: 'approved',
  correct: 'corrected',
  dismiss: 'dismissed',
};
